import { NavMenuItem, useProfileData } from '@liscio/common';
import { Avatar } from '@liscio/ui';

export const LoggedUserMenuItem = () => {
  const { avatar, name, first_name, last_name } = useProfileData();

  const initials = (
    first_name?.trim?.()[0] ??
    last_name?.trim?.()[0] ??
    name?.trim?.()[0] ??
    ''
  )?.toUpperCase();

  return (
    <NavMenuItem
      id="user-menu-button"
      icon={
        <Avatar
          sx={{ width: '32px', height: '32px', border: 'none' }}
          alt={name}
          src={avatar || undefined}
        >
          {initials}
        </Avatar>
      }
      to={'/profile/details'}
      label={name}
    />
  );
};
